import React from "react";
import "./_404.css";
import { useNavigate } from "react-router-dom";

function PageNotFound() {
  const navigate = useNavigate();
  return (
    <center>
      <br />
      <br />
      <img id="_rocket_" width={"20%"} src="rocket.png" />
      <p
        style={{
          fontSize: "2.1rem"
        }}
      >
        Oops! we are unable to take off, as we encountered 404 error<br />PAGE
        NOT FOUND!!
      </p>
      <br />
      <button
        onClick={() => {
          navigate("/");
        }}
        style={{
          backgroundColor: "#38A0EA",
          border: "1px solid #38A0EA",
          padding: "10px",
          fontSize: "1.5rem",
          color: "white",
          borderRadius: "10px",
          cursor: "pointer"
        }}
      >
        Return Home
      </button>
    </center>
  );
}

export default PageNotFound;
